import React from "react";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import SubTitle from "../Utilities/SubTitle";
import BrandCard from "./BrandCard";
import brand1 from "../../Images/brand1.png";
import { useTranslation } from "react-i18next";
import HomeBrandHook from "../../hook/brand/HomeBrandHook";
const BrandFeatured = ({ title, btntitle }) => {
  const [brand, loading] = HomeBrandHook();
  const { t } = useTranslation();



  return (
    <Container>
      <SubTitle title={title} btntitle={btntitle} path="allbrand" />
      <Col className="my-2 d-flex justify-content-start random-container">
        {loading === false ? (
          brand.data ? (
            brand.data.slice(0, 5).map((el) => {
              return <BrandCard id={el._id} key={el._id} img={el.logo} />;
            })
          ) : (
            <h3 className="text-center"> {t("no brands")} </h3>
          )
        ) : (
          <Spinner animation="border" variant="primary" />
        )}
      </Col>
    </Container>
  );
};

export default BrandFeatured;
